import React, { useState } from 'react';
import Icon from '../icon';
import { AlertTitle, AlertDescription, Alert as AlertUI } from '../ui/alert';

type AlertTypes = 'warning' | 'error' | 'info' | 'success';

type Props = {
  type?: AlertTypes;
  title?: string;
  children?: any;
  className?: string;
  defaultOpen?: boolean;
};

const getIcon = (type: AlertTypes) => {
  switch (type) {
    case 'info':
      return <Icon type="info__filled" />;
    case 'error':
      return <Icon type="close_round__filled" />;
    case 'warning':
      return <Icon type="warning" />;
    case 'success':
      return <Icon type="check_circle__filled" />;
    default:
      return null;
  }
};

export const Alert = ({
  children,
  type = 'info',
  className,
  title,
  defaultOpen,
}: Props) => {
  const [show, setShow] = useState(defaultOpen === false ? false : (!title || !!children));

  return (
    <AlertUI variant={type} className={className}>
      {getIcon(type)}
      {title && (
        <AlertTitle className="tw-cursor-pointer tw-select-none" onClick={children && (() => setShow(!show))}>
          {title}
        </AlertTitle>
      )}
      {show && (
        <AlertDescription className="[&_a]:tw-font-semibold hover:[&_a]:tw-underline">
          {children}
        </AlertDescription>
      )}
    </AlertUI>
  );
};
